(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-variant-pills"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const formatMoney = (cents) => {
      return `${(cents / 100).toFixed(2)}`;
    };

    const setMainImageInWrap = (wrap, url, altText) => {
      if (!wrap || !url) return;
      wrap.replaceChildren();
      const img = document.createElement('img');
      img.className = 'variant-pills__main-image';
      img.src = url;
      if (altText) img.alt = altText;
      img.setAttribute('loading', 'lazy');
      img.setAttribute('decoding', 'async');
      wrap.appendChild(img);
    };

    document.addEventListener('click', (event) => {
      const thumb = event.target.closest('.variant-pills__thumb');
      if (!thumb || thumb.tagName !== 'BUTTON') return;
      const sectionNode = thumb.closest('.variant-pills');
      if (!sectionNode) return;
      const wrap = sectionNode.querySelector('.variant-pills__main-image-wrap');
      const imageUrl = thumb.getAttribute('data-image-url');
      if (!wrap || !imageUrl) return;
      sectionNode.querySelectorAll('.variant-pills__thumb').forEach((node) => node.classList.remove('is-active'));
      thumb.classList.add('is-active');
      const alt = thumb.getAttribute('aria-label') || '';
      setMainImageInWrap(wrap, imageUrl, alt);
    });

    document.querySelectorAll('.variant-pills').forEach((sectionNode) => {
      const optionButtons = sectionNode.querySelectorAll('[data-option-value]');
      const bundleButtons = sectionNode.querySelectorAll('[data-bundle-option]');
      const variantInput = sectionNode.querySelector('[data-product-id-input]');
      const quantityInput = sectionNode.querySelector('[data-quantity-input]');
      const finalPriceEl = sectionNode.querySelector('[data-final-price]');
      const oldPriceEl = sectionNode.querySelector('[data-old-price]');
      const ctaButton = sectionNode.querySelector('[data-submit-cta]');
      const mainImageWrap = sectionNode.querySelector('.variant-pills__main-image-wrap');
      const variantsJsonNode = sectionNode.querySelector('[data-variants-json]');
      const ctaDefault = sectionNode.dataset.ctaDefault || 'Add to cart';
      const ctaSoldOut = sectionNode.dataset.ctaSoldOut || 'Sold out';
      const moneyFormat = sectionNode.dataset.moneyFormat || window?.Shopify?.money_with_currency_format || window?.Shopify?.money_format || '${amount}';
      const currencyCode = sectionNode.dataset.currencyCode || '';

      const formatPrice = (cents) => {
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents, moneyFormat);
        }
        const numeric = formatMoney(cents);
        if (currencyCode) return `${numeric} ${currencyCode}`;
        return numeric;
      };

      const variantsData = variantsJsonNode ? JSON.parse(variantsJsonNode.textContent) : [];
      const selectedOptions = {};
      let selectedBundle = sectionNode.querySelector('[data-bundle-option].is-active') || bundleButtons[0];

      const setActive = (nodes, activeNode) => {
        nodes.forEach((node) => {
          const isActive = node === activeNode;
          node.classList.toggle('is-active', isActive);
          node.setAttribute('aria-checked', isActive ? 'true' : 'false');
        });
      };

      optionButtons.forEach((button) => {
        const optionIndex = Number(button.dataset.optionIndex || 1);
        if (button.classList.contains('is-active')) {
          selectedOptions[optionIndex] = button.dataset.optionValueText;
        }
      });

      const getSelectedVariant = () => {
        const matchedVariants = variantsData.filter((variant) => {
          let isMatch = true;

          Object.keys(selectedOptions).forEach((indexKey) => {
            const optionIndex = Number(indexKey) - 1;
            if (variant.options[optionIndex] !== selectedOptions[indexKey]) {
              isMatch = false;
            }
          });

          return isMatch;
        });

        if (matchedVariants.length === 0) return variantsData[0];

        const firstAvailableMatch = matchedVariants.find((variant) => variant.available);
        if (firstAvailableMatch) return firstAvailableMatch;

        return matchedVariants[0];
      };

      const refreshPrice = () => {
        if (!variantInput || !quantityInput || !finalPriceEl || !oldPriceEl || variantsData.length === 0) return;

        const selectedVariant = getSelectedVariant();
        const variantPrice = Number(selectedVariant.price || 0);
        const quantity = Number(selectedBundle?.dataset.bundleQuantity || 1);
        const discount = Number(selectedBundle?.dataset.bundleDiscount || 0);
        const isAvailable = selectedVariant.available === true;

        const baseTotal = variantPrice * quantity;
        const discountedTotal = Math.round(baseTotal * (100 - discount) / 100);
        const showDiscount = discount > 0 && discountedTotal < baseTotal;

        finalPriceEl.textContent = formatPrice(discountedTotal);
        oldPriceEl.textContent = showDiscount ? formatPrice(baseTotal) : '';
        oldPriceEl.classList.toggle('is-hidden', !showDiscount);

        variantInput.value = selectedVariant.id;
        quantityInput.value = quantity;

        if (ctaButton) {
          ctaButton.disabled = !isAvailable;
          ctaButton.textContent = isAvailable ? ctaDefault : ctaSoldOut;
        }

        const variantImageUrl = selectedVariant.featured_image;
        if (variantImageUrl && mainImageWrap) {
          const matchedThumb = Array.from(sectionNode.querySelectorAll('.variant-pills__thumb')).find(
            (node) => node.getAttribute('data-image-url') === variantImageUrl
          );
          const alt = matchedThumb ? matchedThumb.getAttribute('aria-label') || '' : '';
          setMainImageInWrap(mainImageWrap, variantImageUrl, alt);
          sectionNode.querySelectorAll('.variant-pills__thumb').forEach((node) => {
            node.classList.toggle('is-active', node.getAttribute('data-image-url') === variantImageUrl);
          });
        }
      };

      optionButtons.forEach((button) => {
        button.addEventListener('click', () => {
          const optionIndex = button.dataset.optionIndex;
          const groupButtons = sectionNode.querySelectorAll(`[data-option-value][data-option-index="${optionIndex}"]`);
          selectedOptions[optionIndex] = button.dataset.optionValueText;
          setActive(groupButtons, button);
          refreshPrice();
        });
      });

      bundleButtons.forEach((button) => {
        button.addEventListener('click', () => {
          selectedBundle = button;
          setActive(bundleButtons, button);
          refreshPrice();
        });
      });

      refreshPrice();
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
